import { supabaseClient } from "@/supabase/app";
import { enqueueSnackbar } from "notistack";

export interface IcpProfile {
  name: string;
  id?: number;
  created_at?: string;
  user_id: number;
  user_name: string;
  status: string;
  question1: string;
  question2: string;
  question3: string;
  question4: string;
  question5: string;
  question6: string;
  question7: string;
  question8: string;
  question9: string;
  question10: string;
  question11: string;
  question12: string;
  question13: string;
  question14: string;
  question15: string;
  question16: string;
  question17: string;
  question18: string;
  question19: string;
  question20: string;
  question21: string;
  question22: string;
  question23: string;
  question24: string;
  question25: string;

  [key: number]: number | undefined;
}

export interface VpsProfile {
  id?: number;
  user_id: number;
  name: string;
  user_name: string;
  status: string;
  question1: string;
  question2: string;
  question3: string;
  question4: string;
  question5: string;
  question6: string;
  question7: string;
  question8: string;
  question9: string;
  question10: string;
}
export async function addIcpProfile(formData: IcpProfile, message: string) {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .insert([formData])
      .select() // Explicitly request the inserted data
      .single(); // Use single() to get the specific inserted record

    if (error) {
      throw error;
    }

    console.log(data, "Inserted data"); // Log the returned data

    enqueueSnackbar(message, {
      variant: "success",
    });

    return data; // Return the specific object data after adding
  } catch (error) {
    enqueueSnackbar(`Error adding profile: ${error.message}`, {
      variant: "error",
    });
    return null; // Optionally return null or undefined to indicate failure
  }
}

export async function updateIcpProfile(
  profileId: string,
  updatedData: Partial<IcpProfile>,
  message: string
) {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .update(updatedData)
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar(message, {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error updating profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function deleteIcpProfile(profileId: number) {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .delete()
      .eq("id", profileId);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Profile Deleted Successfully", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getAllIcps(userId: number): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .select("*")
      .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}
export async function getIcps(): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .select("*");
    // .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}
export async function getIcpProfileById(id: number) {
  try {
    const { data, error } = await supabaseClient
      .from("icp_profiles")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      throw error;
    }

    return data; // Return the profile data
  } catch (error) {
    enqueueSnackbar(`Error fetching profile: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getAllVps(userId: number): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .select("*")
      .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getVps(): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .select("*");
    // .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}
export async function addVpsProfile(formData: VpsProfile, message: string) {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .insert([formData])
      .select() // Explicitly request the inserted data
      .single(); // Use single() to get the specific inserted record

    if (error) {
      throw error;
    }

    console.log(data, "Inserted data"); // Log the returned data

    enqueueSnackbar(message, {
      variant: "success",
    });

    return data; // Return the specific object data after adding
  } catch (error) {
    enqueueSnackbar(`Error adding profile: ${error.message}`, {
      variant: "error",
    });
    return null; // Optionally return null or undefined to indicate failure
  }
}

export async function updateVpsProfile(
  profileId: number,
  updatedData: Partial<IcpProfile>,
  message: string
) {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .update(updatedData)
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar(message, {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error updating profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getVpsProfileById(id: number) {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      throw error;
    }

    return data; // Return the profile data
  } catch (error) {
    enqueueSnackbar(`Error fetching profile: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function deleteVpsProfile(profileId: number) {
  try {
    const { data, error } = await supabaseClient
      .from("vps_profiles")
      .delete()
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar("Profile Deleted Successfully", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getAllBmas(userId: number): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .select("*")
      .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getBmas(): Promise<IcpProfile[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .select("*");
    // .eq("user_id", userId);

    if (error) {
      throw error;
    }
    return data as IcpProfile[];
  } catch (error) {
    enqueueSnackbar(`Error fetching target markets: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function addBmaProfile(formData: VpsProfile, message: string) {
  try {
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .insert([formData])
      .select() // Explicitly request the inserted data
      .single(); // Use single() to get the specific inserted record

    if (error) {
      throw error;
    }

    console.log(data, "Inserted data"); // Log the returned data

    enqueueSnackbar(message, {
      variant: "success",
    });

    return data; // Return the specific object data after adding
  } catch (error) {
    enqueueSnackbar(`Error adding profile: ${error.message}`, {
      variant: "error",
    });
    return null; // Optionally return null or undefined to indicate failure
  }
}

export async function updateBmaProfile(
  profileId: number,
  updatedData: Partial<IcpProfile>,
  message: string
) {
  try {
    console.log(profileId, updatedData, message);
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .update(updatedData)
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar(message, {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error updating profile: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getBmaProfileById(id: number) {
  try {
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      throw error;
    }

    return data; // Return the profile data
  } catch (error) {
    enqueueSnackbar(`Error fetching profile: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function deleteBmaProfile(profileId: number) {
  try {
    const { data, error } = await supabaseClient
      .from("bma_profiles")
      .delete()
      .eq("id", profileId); // assuming 'id' is the unique identifier for the profile

    if (error) {
      throw error;
    }

    enqueueSnackbar("Profile Deleted Successfully", {
      variant: "success",
    });
    return data;
  } catch (error) {
    enqueueSnackbar(`Error deleting profile: ${error.message}`, {
      variant: "error",
    });
  }
}

interface CicProfile {
  id?: number;
  user_id: string;
  status: string;
}

export async function upsertCicProfile(formData: CicProfile) {
  try {
    let data, error;

    const response = await supabaseClient
      .from("cic_profiles")
      .select("*")
      .eq("id", formData.id)
      .single();

    console.log(response.data);

    if (response.data !== null) {
      const updateResponse = await supabaseClient
        .from("cic_profiles")
        .update(formData)
        .eq("id", formData.id)
        .select()
        .single();

      data = updateResponse.data;
      error = updateResponse.error;
    } else {
      const insertResponse = await supabaseClient
        .from("cic_profiles")
        .insert([formData])
        .select()
        .single();

      data = insertResponse.data;
      error = insertResponse.error;
    }

    if (error) {
      throw error;
    }

    console.log(data, formData.id ? "Updated data" : "Inserted data");
    return data;
  } catch (error) {
    enqueueSnackbar(
      `Error ${formData.id ? "updating" : "adding"} profile: ${error.message}`,
      {
        variant: "error",
      }
    );
    return null;
  }
}

export async function getCicProfileById(id: number) {
  try {
    const { data, error } = await supabaseClient
      .from("cic_profiles")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    // enqueueSnackbar(`Error fetching profile: ${error.message}`, {
    //   variant: "error",
    // });
    return null;
  }
}
